var exports = {
  "bL": "Root__C-J7Xs",
  "ot": "CommandPicker__WOEHcb",
  "Si": "MethodButton__O3Rg2M",
  "uB": "Command__9pRv9N",
  "zl": "CommandText__NoS4Ce",
  "i8": "CopyButton__W24xsM",
  "wi": "Footer__rzsRrm",
};

module.exports = exports;
